module.exports = "/_next/static/images/monthly-stats-a316a32570dfecd31b1da1c1075d19be.jpg";